/**
 * @fileoverview ColorThemeSelector - Dropdown for selecting from 8 standalone themes.
 *
 * Provides a grouped dropdown selector for changing between 4 light themes and
 * 4 dark themes. Each theme is self-contained with no separate light/dark mode toggle.
 *
 * @module components/ThemeProvider/ColorThemeSelector
 */

import { useTheme, COLOR_THEMES, THEME_LABELS } from './ThemeProvider';
import styles from './ColorThemeSelector.module.css';

const THEME_COLORS = {
  [COLOR_THEMES.BLUE]: '#0369a1',
  [COLOR_THEMES.GREEN]: '#059669',
  [COLOR_THEMES.PURPLE]: '#7c3aed',
  [COLOR_THEMES.ORANGE]: '#ea580c',
  [COLOR_THEMES.BLUE_DARK]: '#3b82f6',
  [COLOR_THEMES.MIDNIGHT_DARK]: '#58a6ff',
  [COLOR_THEMES.WARM_DARK]: '#1264a3',
  [COLOR_THEMES.GRAPHITE_DARK]: '#2eaadc'
};

export const ColorThemeSelector = ({ className = '' }) => {
  const { colorTheme, setColorTheme } = useTheme();

  return (
    <div className={`${styles.container} ${className}`}>
      <select
        value={colorTheme}
        onChange={(e) => setColorTheme(e.target.value)}
        className={styles.select}
        aria-label="Select color theme"
      >
        <optgroup label="Light Themes">
          <option value={COLOR_THEMES.BLUE}>{THEME_LABELS[COLOR_THEMES.BLUE]}</option>
          <option value={COLOR_THEMES.GREEN}>{THEME_LABELS[COLOR_THEMES.GREEN]}</option>
          <option value={COLOR_THEMES.PURPLE}>{THEME_LABELS[COLOR_THEMES.PURPLE]}</option>
          <option value={COLOR_THEMES.ORANGE}>{THEME_LABELS[COLOR_THEMES.ORANGE]}</option>
        </optgroup>
        <optgroup label="Dark Themes">
          <option value={COLOR_THEMES.BLUE_DARK}>{THEME_LABELS[COLOR_THEMES.BLUE_DARK]}</option>
          <option value={COLOR_THEMES.MIDNIGHT_DARK}>{THEME_LABELS[COLOR_THEMES.MIDNIGHT_DARK]}</option>
          <option value={COLOR_THEMES.WARM_DARK}>{THEME_LABELS[COLOR_THEMES.WARM_DARK]}</option>
          <option value={COLOR_THEMES.GRAPHITE_DARK}>{THEME_LABELS[COLOR_THEMES.GRAPHITE_DARK]}</option>
        </optgroup>
      </select>
      <div
        className={styles.indicator}
        style={{ backgroundColor: THEME_COLORS[colorTheme] }}
        aria-hidden="true"
      />
    </div>
  );
};

export default ColorThemeSelector;
